/**
 * 索赔2.0
 * 仓库发起|调整
 *  两个入口
 *  出货订单-详情-单品发起索赔 (add 为true)
 *  索赔列表-仓库发起-详情 (add 为false)
 *
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/8/31      1.0     First version
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React from "react";
import {Spin, message, Empty, Alert, Popconfirm,} from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import dayjs from "dayjs";
import {symbolMoneyUtil,getQueryString,isEmptyObject,getFileSuffix} from '@utils/utils';
import { renderFileType } from "@components/UploadFile/UploadImage/file.util";
import History from "../ClaimDemageInfo/components/History"
import ClaimSkuWrap from "../../../components/claimSkuWrap/SkuWrap";
import TypeBreakage from "./components/typeBreakage";
import AfterSaleService from '../AfterSale.action';
import "./index.less";
import SuccessComponent from "./components/success";
import PageCommon from  "@components/PageCommon/PageCommon";
import Lang from "@components/Lang/Lang";
import ModalOrderDetail from "@components/ModalOrderDetails/ModalOrderDetail";

export default class AfterSaleInitiated extends React.Component{
    static defaultProps = {
        add: true, //默认为true
    };
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            poItemId:"",
            showSuccess:false,
            sku:{}, // 该po商品内容
            model:{},//索赔详情
        }
        this.__getServerLanguage = __getServerLanguage;
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /**
     * 点击确认时 保护表单数据
     * 破损申请提交    http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7960
     * 索赔审核提交   http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#6273
     ***/
    save(postData={}){
        let sUrl ="";
        const { add,claimDemageOrderId } = this.props;
        if(add){ // 新增时
             sUrl = "/service/mg/sale/claimDemage/damaged-apply";
            // 申请文件Id 索赔方式为 20:现金时 必填 索赔2.0新增
            const { poItemId ,sku} = this.state;
            postData["poId"] = sku.poId;
            postData["poItemId"] = poItemId;
            postData["buyerId"] = sku.buyerId; // 发起时此内容是跟查询po时返回的
        }else { // 调整时
            sUrl = "/service/mg/sale/claimDemage/audit/submit";
            postData["claimDemageOrderId"] = claimDemageOrderId;
            postData["status"] = 3; //2: 审核通过 3 : 审核不通过, 调整时 将状态改为不通过
        }
        this.loading(true);
        AfterSaleService.postHttpAction(sUrl,postData,).then((resp)=>this.handleSaveRes(resp.data)).catch(err=>this.handleSaveRes(err));
    }
    handleSaveRes(resData={}){
        this.loading(false);
        const { success, valid,model={}} = resData;
        if (success &&valid) {
            // 保存成功
            const { add } = this.props;
            if(add){ // 新增时
                this.setState({
                    showSuccess: true,
                    afterId: model.id
                })
            }else { // 调整
                // 刷新页面
                if(this.props.successBack)this.props.successBack();
            }
        }else if(resData.message){
            message.warning(resData.message)
        }else {
            message.warning(this.__getServerLanguage("BaoCunShiBai"))
        }
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    /**
     * 查看详情
     * */
    init(){
        const sId = getQueryString("poItemId");
        const { add } = this.props;
        if(sId&&add){ // 发起的才进这里
            const data ={
                poItemId: sId,
            }
            const sUrl =  "/service/mg/sale/claimDemage/query-po-info";
            this.loading(true)
            AfterSaleService.postHttpAction(sUrl,data).then((resp)=>this.handleRes(resp.data,sId)).catch(err=>this.handleRes(err));
            // todo sku.claimQuantity&&sku.claimQuantity>0 ? sku.quantity - sku.claimQuantity : sku.quantity
        }else {
            const { add,claimDemageOrderId,model } = this.props;
            if(!add&&claimDemageOrderId&&!isEmptyObject(model)){
                const sku = model.mgPoInfoVO||{};
                const fromInitialValues = {
                    damageCode:model.damageCode,
                    // 协商上传文件，不用
                    // consultFileList:model.consultFileList&&model.consultFileList.length>0?model.consultFileList[0].consultFileList:[],
                    claimType:model.claimType,
                    remark:model.remark,
                    quantity:model.quantity, // 协商的数量
                    normalQuantity:model.normalQuantity, //正常数量
                    wornQuantity:model.wornQuantity, //正常数量
                    refundAmountTotal:model.refundAmountTotal, //退款
                }
                const canApplyNum = sku.claimQuantity&&sku.claimQuantity>0 ? sku.quantity - sku.claimQuantity : sku.quantity; // mgPoInfoVO 内的总量quantity - 已索赔的数量claimQuantity
                this.setState({
                    model:model,
                    sku: sku,
                    poItemId: sku.poItemId,
                    fromInitialValues:fromInitialValues,
                    canApplyNum: canApplyNum,
                })
            }
        }
    }
    handleRes(resData={},poItemId=""){
        // 响应结果
        this.loading(false)
        const { success,valid,model} = resData;
        const canApplyNum = model.claimQuantity&&model.claimQuantity>0 ? model.quantity - model.claimQuantity : model.quantity; // model 内的总量quantity - 已索赔的数量claimQuantity
        if(success&valid){
            this.setState({
                sku:model,
                poItemId:poItemId,
                containerId : getQueryString("containerId"),
                canApplyNum: canApplyNum,
            })
        }
    }
    /*
     * 获取赔偿方式
     * */
    getClaimType(type,list=[]){
        if(type&&list.length>0){
            const item = list.find(item=>item.code==type);
            if(item){
                return item.name
            }else return ""
        }
        return ""
    }
    getBreadcrumb() {
        const { add } = this.props;
        const currPageName = Lang({id: "FaQiShouHouTuiKuan",default: "发起售后退款"});
        if(add){
            return [
                { name:Lang({id: "YiChuHuoJiGuiDanLieBiao",default: "已出货集柜单列表"}),link:'/shipperManagement/shippingOrder/list'},
                { name:Lang({id: "YiChuHuoDingDanXiangQing",default: "已出货订单详情"}),link:'/shipperManagement/shippingOrder/detail?'+this.state.containerId},
                { name:currPageName}]
        }else  return [
            { name:Lang({id: "CangKuFaQiLieBiao",default: "仓库发起列表"}),link:'/afterSale/warehouseInitiated'},
            { name:currPageName}]
    }
    /*
     * 渲染详情子项
     * */
    renderDesc(title="",desc="",threeRow){
        return (<div className={"mt_16"}>
            <div className={"black89 font_16 fw_700 lineH_24"}>{title}</div>
            {desc&&<div className={"black66 font_14"}>{desc}</div>}
            {threeRow&&<div className={"black66 font_14"}>{threeRow}</div>}
        </div>)
    }
    /*
     * 付款登录操作
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7948
     * */
    handlePay(){
        const {claimDemageOrderId,model } = this.props;
        if(claimDemageOrderId){
            const data ={
                id:claimDemageOrderId,
                serviceTypeCode: model.type
            }
            const sUrl =  "/service/mg/sale/claimDemage/refund/dispose";
            this.loading(true)
            AfterSaleService.postHttpAction(sUrl,data,).then((resp)=>this.handleSaveRes(resp.data)).catch(err=>this.handleSaveRes(err));
        }
    }
    /*
    * 撤消操作
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7948
    * */
    handleCancel(){
        if(this.props.handleCancel){
            this.props.handleCancel();
        }
    }
    componentWillMount() {
        if(this.props.onRef)this.props.onRef(this);
    }
    componentDidMount(){
        this.init()
    }
    render(){
        const { add, } = this.props;
        const { model,loading, poItemId ,sku,showSuccess,afterId,fromInitialValues,canApplyNum} = this.state;
        // 单位
        const sUnit = sku.skuCount>1?"PCS":__getServerDictItem("unit_type." + sku.skuUnit);
        return (<Spin spinning={loading}>
                <PageCommon>
            <CommonBreadcrumb list={this.getBreadcrumb()}></CommonBreadcrumb>
            <div className={"afterSaleWrap black89 font_14"}>
                {add&&showSuccess?<SuccessComponent {...this.props} afterId={afterId} />:(poItemId&&sku.skuNo?<div className={"main"}>
                    <div className={"flex-item-between"}>
                        <div>
                            <div className={"flex-item-ver-center fw_700 font_18"}>
                                {add?Lang({id:'FaQiShouHouTuiKuan',default:"发起售后退款"}):<>
                                    {Lang({id:'ShouHou',default:"售后"})}<span className={"ml_6"}>{model.demageCode}</span>
                                </>}
                            </div>
                            {/* 时间 */}
                            {!add&&<div className={"mt_2 black45"}>
                                {model.demageCreateTime?dayjs(model.demageCreateTime).format('YYYY-MM-DD HH:mm:ss'):"-"}
                            </div>}
                        </div>
                        {/*  canClose 0:不显示, 1:显示*/}
                        {model.canClose=="1"&&<Popconfirm overlayClassName={"poAfterDetailPopconfirm"}
                                                                    title={<div className={"black89 font_14"}>
                                                                        <div className={"font_18 fw_700"}>{Lang({id:"TiShi",default:"提示"})}</div>
                                                                        {Lang({id:"ShiFouYaoGuanBiSuoPeiShenQing",default:"是否要关闭赔偿申请"})}
                                                                    </div>}
                                                                    icon={null}
                                                                    onConfirm={()=>this.handleCancel()}
                                                                    okText={__getServerLanguage('QueDing')}
                                                                    cancelText={__getServerLanguage('QuXiao')}>
                            <div className={"btnCancel"}>
                                {Lang({id:"GuanBiPeiChang",default:"关闭赔偿"})}
                            </div>
                        </Popconfirm>}
                        {/* 7:待汇款  适应所有类型   */}
                        {/*{!add&&model.statusMg=="7"&&<Popconfirm overlayClassName={"poAfterDetailPopconfirm"}*/}
                                                          {/*title={<div className={"black89 font_14"}>*/}
                                                              {/*<div className={"font_18 fw_700"}>{Lang({id:"TiShi",default:"提示"})}</div>*/}
                                                              {/*{Lang({id:"QueRenYiJingHuiKuanGeiKeHuJiangSuoPeiDanBiaoShiWeiYiHuiKuan",default:"确认已经汇款给客户，将索赔单标识为已汇款？"})}*/}
                                                          {/*</div>}*/}
                                                          {/*icon={null}*/}
                                                          {/*onConfirm={()=>this.handlePay()}*/}
                                                          {/*okText={Lang({id:'QueDing',default: "确定"})}*/}
                                                          {/*cancelText={Lang({id:'QuXiao',default: "取消"})} >*/}
                            {/*<div className={"btnPay"}>*/}
                                {/*{Lang({id:"HuiKuan",default:"汇款"})}*/}
                            {/*</div>*/}
                        {/*</Popconfirm>}*/}
                    </div>
                    {/*  工作台状态：9:已发起 工作台调整保存后 将回归为9 */}
                    {model.statusMg=="9"&&<Alert className={"mt_16"} type="warning" message={Lang({id:"DengDaiKeHuChuLi",default:"等待客户处理"})} showIcon />}
                    <div className={"mt_16 clientInfo"}>
                        <div className={'black89 font_16 fw_700'}>
                            {Lang({id:'KeHuXinXi',default:"客户信息"})}
                        </div>
                        <div className={"mt_4"}>
                            <a className={"color-blue"} target={"_blank"} href={"/customer/detail?id="+(sku.buyerId||model.buyerId)}>{sku.buyerCode||model.buyerCode}</a>
                            <span className={"ml_20"}>{sku.buyerName||model.buyerName}</span>
                        </div>
                    </div>
                    <div className={"lineGrey"} />
                    <div className={"mt_16 font_16 mb_4 black89"}>
                        {this.__getServerLanguage("DingDan")}
                        <span className={"ml_4 cursor-p color-blue"}><ModalOrderDetail id={sku.mgPoInfoVO&&sku.mgPoInfoVO.poId}>{sku.poCode}</ModalOrderDetail></span>
                    </div>
                    <div className={"mb_16"}>
                        <ClaimSkuWrap item={sku} />
                    </div>
                    {!add&&<>
                        <History model={model} height={450}/>
                        <div className={"lineGrey"} />
                    </>}
                    {/* 非发起时 (即已生成索赔model)只有待处理状态 可调整 */}
                    {(add||model.statusMg=="1")?<TypeBreakage add={add} sku={sku} saveData={(data)=>this.save(data)} canApplyNum={canApplyNum} fromInitialValues={fromInitialValues} />:<>
                        {this.renderDesc(Lang({id:"ShouHouYuanYin",default:"售后原因"}))}
                        <div className={"btnSelectOn mt_4"}>{model.damageCodeName}</div>
                        {/*  +"（"+Lang(
                            {id:'KeHuGouMaiGongN',default:`客户购买共  ${sku.quantity+" "+sUnit}`,
                                params:[sku.quantity+" "+sUnit]})+"）" */}
                        {this.renderDesc( Lang({id:'ShouHouChanPinShuLiang',default:"售后产品数量"}) )}
                        <div className={"btnSelectOn mt_4"}><span className={"fw_700"}>{model.quantity}</span>{sUnit}</div>
                        {/*<div className={"color-err mt_4"}>{Lang({id:'GaiBuFenHuoWuKeHuBuYaoLeXuYaoTuiKuan',default:"该部分货物客户不要了，需要退款"})}</div>*/}
                        {/*<div className={"mt_4 color-black font_16"}>*/}
                            {/*<span className={"fw_700 mr_2"}>{model.quantity}</span>*/}
                            {/*{sUnit}<span className={"ml_4 mr_4"}>*</span>*/}
                            {/*{symbolMoneyUtil(sku.pcsPrice, sku.currencySymbol)}，*/}
                            {/*<span className={"mr_4"}>{Lang({id: "ZongJi",default: "总计"})}</span>*/}
                            {/*{symbolMoneyUtil(sku.pcsPrice*model.quantity, sku.currencySymbol)}*/}
                            {/*/!*{symbolMoneyUtil(model.refundAmountTotal, sku.currencySymbol)}*!/*/}
                        {/*</div>*/}
                        {/*<div className={"black66 mt_4"}>*/}
                            {/*{sku.skuCount>1&&<span>{sku.skuCount} PCS/{__getServerDictItem("unit_type." + sku.skuUnit)} ，</span>}*/}
                            {/*{sku.skuCapacity}<span className={"ml_2"}>{__getServerDictItem("unit_type." + sku.skuUnit)}/{__getServerDictItem("prd_goods_out_box_unit." + sku.spuOutBoxUnit)||'-'}</span>，*/}
                            {/*/!*可索赔数量 {0}*!/*/}
                            {/*{Lang({id: "KeSuoPeiShuLiang",default: `可索赔数量 ${sku.quantity+" "+sUnit}`,params:[sku.quantity+" "+sUnit]})}*/}
                        {/*</div>*/}
                        {/* 黄色数字输入区域 */}
                        <div className={"yellowNumberArea mt_16 mb_16 black89 autoRowNo"}>
                            <div className={"black100 fw_700"}>{Lang({id:'QueRenPoSunQingKuang',default:`确认破损情况（共 ${model.quantity+" "+sUnit}）`,params:[model.quantity+" "+sUnit]})}：</div>
                            <div className={"flex-item-ver-center mt_8"}>
                                {Lang({id:'ZhengChangChanPin',default:"正常产品"})}
                                <span className={"ml_8 fw_700"}>{model.normalQuantity||0}</span>
                                <span className={"ml_8"}>{sUnit}</span>
                            </div>
                            <div className={"black66 mt_8"}>{Lang({id:'ZhengChangChanPinJiangZiDongZhuanKuCunShangPin',default:"正常产品将自动转库存商品，且会折算成整箱"})}</div>
                            <div className={"lineLigGrey mt_12"}></div>
                            <div className={"flex-item-ver-center mt_12"}>
                                {Lang({id:'PoSunChanPin',default:"破损产品"})}
                                <span className={"ml_8 fw_700"}>{model.wornQuantity||0}</span>
                                <span className={"ml_8"}>{sUnit}</span>
                            </div>
                        </div>
                        <div className={"lineGrey"} />
                        <div className={"mb_4"}>
                            {this.renderDesc(Lang({id:"ShouHouFangAn",default:"售后方案"}))}
                        </div>
                        {/* 优惠券时显示 */}
                        {/*{model.claimType=="10"&&<Alert message={<div className={"black89"}>*/}
                            {/*{Lang({id: "ShouHouTuiKuan",default: "售后退款"})}*/}
                            {/*<span className={"ml_4"}>{model.quantity} {sUnit} * {symbolMoneyUtil(sku.skuCount>1?(sku.pcsPrice||0):(sku.price||0), sku.currencySymbol)}，</span>*/}
                            {/*<span className={"ml_2 mr_2"}>{Lang({id: "ZongJi",default: "总计"})}</span>*/}
                            {/*{symbolMoneyUtil(model.refundAmountTotal, sku.currencySymbol)}*/}
                        {/*</div>} type="warning" showIcon />}*/}
                        <div className={`mt_4${model.claimType=="10"?" color-err":""}`}>{this.getClaimType(model.claimType,__getDictList("sale_po_claim_demage_order_claim_type"))}</div>
                        {/* 现金模式下 有申请 文件 */}
                        {model.claimType=="20"&&model.applyFileUrl&&<a className={"upload-item-thumbnail-link"} href={model.applyFileUrl} target={"_blank"}>
                            <div className={"upload-item-thumbnail"}>
                                {renderFileType(model.applyFileUrl)}
                            </div>
                            <div className={"ellipsis mt_4 font_12 text-center"}>{model.applyFileUrl.substring(model.applyFileUrl.lastIndexOf("\/") + 1, model.applyFileUrl.length)}</div>
                        </a>}
                    </>}
                </div>:(loading?null:<Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                              description={Lang({id: 'ZanWuShuJu',default:'暂无数据'})} />))}
            </div>
        </PageCommon>
        </Spin>)
    }
}

